import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Accessibility from "./pages/Accessibility";
import NotFound from "./pages/NotFound";
import AccessibilityProvider from "./components/AccessibilityProvider";

// התוספת החדשה - סגנונות מתקנים למובייל
const MobileFixStyles = () => (
  <style dangerouslySetInnerHTML={{
    __html: `
      @media (max-width: 768px) {
        html, body, #root {
          width: 100% !important;
          max-width: 100vw !important;
          overflow-x: hidden !important;
          position: relative !important;
        }
        
        body * {
          max-width: 100vw !important;
          box-sizing: border-box !important;
        }
        
        .container, .section-container, section, div {
          max-width: 100vw !important;
          box-sizing: border-box !important;
        }
        
        section, .section-container {
          padding-left: 1rem !important;
          padding-right: 1rem !important;
        }
      }
    `
  }} />
);

const queryClient = new QueryClient();

const App = () => {
  // SEO מידע בסיסי עבור העמודים השונים
  const defaultSEO = {
    title: "שם האתר שלך",
    description: "תיאור האתר שלך עבור מנועי חיפוש",
    canonicalUrl: "https://yourdomain.com",
    ogImage: "https://yourdomain.com/images/og-image.jpg",
    keywords: "מילות מפתח, לאתר, שלך"
  };

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AccessibilityProvider seo={defaultSEO}>
          {/* הוספת סגנונות התיקון */}
          <MobileFixStyles />
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/accessibility" element={<Accessibility />} />

              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </AccessibilityProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;